import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { makeStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  makeSelectShowRegionBanner,
  makeSelectClientDetails,
  makeSelectShowHomepagePro,
} from 'containers/Main/selectors';
import _get from 'lodash/get';
import { isEmbedded } from 'utils/stringUtils';
import { createStructuredSelector } from 'reselect';
import useShortMenu from 'components/useShortMenu';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: 'calc(100vh - 238px)',
  },
  stick: {
    paddingTop: 149,
  },
  shortStick: {
    paddingTop: 75,
  },
  topBannerStick: {
    paddingTop: 201,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 149,
    },
  },
  pt45: {
    paddingTop: 45,
  },
  pt0: {
    paddingTop: 0,
  },
}));
const stateSelector = createStructuredSelector({
  showBanner: makeSelectShowRegionBanner(),
  clientDetails: makeSelectClientDetails(),
  showHomepagePro: makeSelectShowHomepagePro(),
});

function Root(props) {
  const classes = useStyles();
  const isEmbed = isEmbedded();
  const { showBanner, clientDetails, showHomepagePro } = useSelector(
    stateSelector,
  );
  const hasMultipleLanding =
    _get(clientDetails, 'landingLinksCollection.items', []).length > 1;
  const { children } = props;
  const location = useLocation();
  const { pathname, search } = location;
  let isAbout = pathname.includes('/company/');
  let isHomePage = pathname === '/';
  let isLandingPage = pathname.includes('/landing/');
  const { hasClient } = useShortMenu();
  useEffect(() => {
    isHomePage = pathname.includes('/');
    isAbout = pathname.includes('/company/');
    isLandingPage = pathname.includes('/landing/');
  }, [location]);
  const queryParams = qs.parse(search.slice(1));
  const shouldHideInAuthPage =
    pathname.includes('/login') ||
    (pathname.includes('/signup') && queryParams.cr !== '1') ||
    pathname.includes('/forgot_password');

  return (
    <div
      className={ClassNames(classes.root, {
        [classes.stick]:
          !showHomepagePro &&
          !shouldHideInAuthPage &&
          queryParams.showcorp !== '1' &&
          !isAbout &&
          ((showBanner && !isHomePage) ||
            (!showBanner && isHomePage) ||
            (!isAbout && (!isHomePage || hasClient))),
        [classes.topBannerStick]:
          !showHomepagePro &&
          !shouldHideInAuthPage &&
          queryParams.showcorp !== '1' &&
          ((isHomePage && !hasClient) ||
            ((isLandingPage || isHomePage) &&
              (showBanner || hasMultipleLanding))),
        [classes.pt0]: isEmbed,
      })}
    >
      {children}
    </div>
  );
}

Root.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Root;
